import React from "react"
import { connect } from "react-redux"

import Text from "../../common/components/Text"
import Link from "../../common/components/Link"

import { setPassSubmit } from "../actions"
import AuthForm from "./AuthForm"
import PageWrapper from "./PageWrapper"
import { TERMS_URL, PRIVACY_URL } from "../../common/constants"

const SetPass = props => (
  <AuthForm
    title="Create password."
    submitText="Create password & continue"
    showPass
    showPassConfirm
    {...props}
  >
    <Text size="bodyMain">
      {`By clicking “Create password & continue”, you agree to Buoy’s `}
      <Link
        href={TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        size="bodyMain"
      >
        Terms of Use
      </Link>
      {` and `}
      <Link
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        size="bodyMain"
      >
        Privacy Policy
      </Link>
      .
    </Text>
  </AuthForm>
)

const SetPassPage = PageWrapper(SetPass)

const mapStateToProps = state => ({
  authError: state.auth.status.signup,
})

const mapDispatchToProps = {
  onSubmit: setPassSubmit,
}

const SetPassWrapper = connect(mapStateToProps, mapDispatchToProps)(SetPassPage)

export { SetPassWrapper as default, SetPass }



// WEBPACK FOOTER //
// ./assets/auth/components/SetPassPage.js